import { useEffect, useState } from 'react';

import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';

interface UseDeviceTypeLayoutsReturn {
  isMobile: boolean;
}

interface UseResponsiveCountReturn {
  count: number;
  isOverflowed: boolean;
}

interface UseResponsiveCountProps {
  containerRef: React.RefObject<HTMLDivElement>;
}

const CONSTANTS = {
  DEFAULT_COUNT: 10,
  CARD_WIDTH: 106,
  HORIZONTAL_MARGIN: 24,
  CARD_PADDING: 6,
};

export const useResponsiveCount = ({ containerRef }: UseResponsiveCountProps): UseResponsiveCountReturn => {
  const { isMobile } = useDeviceTypeLayouts() as UseDeviceTypeLayoutsReturn;
  const width = containerRef?.current?.getBoundingClientRect()?.width;
  const [count, setCount] = useState(CONSTANTS.DEFAULT_COUNT);

  useEffect(() => {
    if (isMobile) {
      setCount(CONSTANTS.DEFAULT_COUNT);

      return;
    }

    if (width) {
      const firstCardPaddingLeft = CONSTANTS.HORIZONTAL_MARGIN;
      const cardPaddingRight = CONSTANTS.CARD_PADDING;
      const conversionCardRightMargin = CONSTANTS.HORIZONTAL_MARGIN;
      const secondLastChildRight = cardPaddingRight * 2;
      const cardWidth = CONSTANTS.CARD_WIDTH;

      const maxCards = Math.floor(
        (width -
          firstCardPaddingLeft -
          cardWidth -
          secondLastChildRight +
          cardPaddingRight -
          conversionCardRightMargin) /
          (cardWidth + cardPaddingRight),
      );

      setCount(maxCards);
    }
  }, [isMobile, width]);

  return { count, isOverflowed: count < CONSTANTS.DEFAULT_COUNT };
};
